// extracted by mini-css-extract-plugin
export default {"header":"TMwC6","label":"arogj","progress":"gZ_aO","statusContainer":"KDojy","errorFilled":"kKR4E","successFilled":"W1Y56","toggle":"wYcLO","closeBigStakeBarButton":"PuEIz"};